<form [formGroup]="form">
  
  <div class="form-group">
    <label>Access Key</label>
    <input type="text" class="form-control" formControlName="accessKey" />
  </div>

  <div class="form-group">
    <label>Customer ID</label>
    <input type="text" class="form-control" formControlName="customerId" />
  </div>

  <div class="form-group">
    <label>Transaction ID</label>
    <input type="text" class="form-control" formControlName="transactionId" />
  </div>

  <div class="form-group">
    <label>Invoice Field (Cxxxx)</label>
    <input type="text" class="form-control" formControlName="invoiceField" />
  </div>

  <div class="form-group">
    <label>Customer Field (Cxxxx)</label>
    <input type="text" class="form-control" formControlName="customerField" />
  </div>

  <div class="form-group">
    <label>Location Field (Cxxxx)</label>
    <input type="text" class="form-control" formControlName="locationField" />
  </div>

  <div class="form-group">
    <label>Description Field (Cxxxx)</label>
    <input type="text" class="form-control" formControlName="descriptionField" />
  </div>

  

  <!-- <mat-form-field>
    <mat-label>Postback URL (Optional)</mat-label>
    <input matInput formControlName="postBackUrl" />
  </mat-form-field> -->

</form>
